import React from 'react';

import BarChart from '../components/BarChart';

export default class Overview extends React.Component {
  render() {
    return (
      <div id="content-container">
        <BarChart />
      </div>
    );
  }
}
